import { h, render } from "preact";

export default function CompatibleProduct({ product }) {
  return (
    <div className="compare-modal-v2__compatible-product">
      <img
        className="compare-modal-v2__compatible-product-image"
        src={getSizedImageUrl(product.featuredImage.url, "x300")}
        alt={product.featuredImage.altText}
      />
      <div className="compare-modal-v2__compatible-product-title">
        {`${product.title}: ${window
          .formatMoney(product.priceRange.minVariantPrice.amount)
          .replace(/\.00$/, "")}`}
      </div>
    </div>
  );
}
